var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeDropper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8223 10.7559L21.4889 17.4225",
    stroke: "#2B2B35",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11133 20.4446V24.889H11.5558L20.4447 16.0001L16.0002 11.5557L7.11133 20.4446Z",
    stroke: "#2B2B35",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5556 10.333L21.6667 7.44408C21.459 7.2405 21.1797 7.12646 20.8889 7.12646C20.598 7.12646 20.3188 7.2405 20.1111 7.44408L16 11.5552L20.4444 15.9996L24.5556 11.8885C24.7591 11.6808 24.8732 11.4016 24.8732 11.1108C24.8732 10.8199 24.7591 10.5407 24.5556 10.333Z",
    fill: "#2B2B35",
    stroke: "#2B2B35",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDropper);
export default __webpack_public_path__ + "static/media/eye_dropper.b2ff93c178bb2b7b57db8dd0c26062ea.svg";
export { ForwardRef as ReactComponent };